import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ReinforcementRepository from '../../../repositories/ReinforcementRepository';
import ReinforcementDataRepository from '../../../../data/repositories/ReinforcementDataRepository';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.SUBSCRIBE_TO_REINFORCEMENT_REQUEST });
    const { reinforcementId } = action;
    const reinforcementRepository: ReinforcementRepository =
      new ReinforcementDataRepository();
    /* /// prueba de errores --> VACANCIES | ERROR
    yield delay(2000);
    yield put({
      type: Types.SUBSCRIBE_TO_REINFORCEMENT_FAILURE,
      error: 'VACANCIES'
    });
    return; */

    const reinforcementResponse = yield call(
      reinforcementRepository.subscribeReinforcements,
      reinforcementId
    );

    if (!reinforcementResponse) {
      yield put({
        type: Types.SUBSCRIBE_TO_REINFORCEMENT_FAILURE,
        error: 'ERROR'
      });
    }
    const { message } = reinforcementResponse;
    if (message === 'OK') {
      yield put({
        type: Types.SUBSCRIBE_TO_REINFORCEMENT_SUCCESS,
        data: reinforcementResponse
      });
    }
    if (message === 'No vacancies') {
      yield put({
        type: Types.SUBSCRIBE_TO_REINFORCEMENT_FAILURE,
        error: 'VACANCIES'
      });
    }
    if (message === 'ZOOMACCOUNTNOTEXISTS') {
      yield put({
        type: Types.SUBSCRIBE_TO_REINFORCEMENT_FAILURE,
        error: 'ZOOMACCOUNTNOTEXISTS'
      });
    }
    if (message === 'ZOOMACCOUNTDISABLE') {
      yield put({
        type: Types.SUBSCRIBE_TO_REINFORCEMENT_FAILURE,
        error: 'ZOOMACCOUNTDISABLE'
      });
    }

    // if (data?.result) {
    //   yield put({
    //     type: Types.SUBSCRIBE_TO_REINFORCEMENT_SUCCESS,
    //     data: reinforcementResponse
    //   });
    // } else {
    //   yield put({
    //     type: Types.SUBSCRIBE_TO_REINFORCEMENT_FAILURE,
    //     error: 'VACANCIES'
    //   });
    // }
  } catch (error) {
    yield put({
      type: Types.SUBSCRIBE_TO_REINFORCEMENT_FAILURE,
      error: 'ERROR'
    });
  }
}
